<template>
  <div>
    <el-button type="primary" size="small" icon="el-icon-back" @click="$router.back(-1)" style="margin-bottom:10px;">返回</el-button>
    <UserForm v-if="active===0" @next="next"/>
    <NotaryForm v-if="active===1" @next="next"/>
    <SelectSignature v-if="active===2"/>
  </div>
</template>

<script>
import UserForm from './dialog-form';
import NotaryForm from './notary-form';
import SelectSignature from './SelectSignature';
export default {
  components: {
    UserForm,
    NotaryForm,
    SelectSignature
  },
  data() {
    return {
      active: 0
    }
  },
  methods: {
    next() {
      this.active ++;
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .el-steps--horizontal {
  width: 500px;
  margin-top: 20px;
  white-space: nowrap;
}
</style>